import { defaultInitialState } from '../utils';
import { FETCH_ALERT_PREFERENCES, FETCH_ALERT_PREFERENCES_DONE, FETCH_ALERT_PREFERENCES_ERROR, SET_ALERT_PREFERENCES, SET_ALERT_PREFERENCES_DONE, SET_ALERT_PREFERENCES_ERROR, SET_ALERT_CHANNEL, SET_ALERT_CHANNEL_DONE, SET_ALERT_CHANNEL_ERROR, RESET_ALERT_PREFERENCES } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: {} });
// eslint-disable-next-line complexity
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALERT_PREFERENCES:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case FETCH_ALERT_PREFERENCES_DONE:
            return Object.assign(Object.assign({}, state), { data: action.data, isLoading: false, error: false, errorMessage: null });
        case FETCH_ALERT_PREFERENCES_ERROR:
        case SET_ALERT_PREFERENCES_ERROR:
        case SET_ALERT_CHANNEL_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case SET_ALERT_PREFERENCES:
        case SET_ALERT_CHANNEL:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case SET_ALERT_PREFERENCES_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case SET_ALERT_CHANNEL_DONE:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), action.data), isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case RESET_ALERT_PREFERENCES:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map